{
  "customer-form": {
    "field": {
      "available_points": "Available points",
      "birthday": "Birthday",
      "black_listed": "Blacklist",
      "black_listed_hint": "Customer in blacklist cannot book online appointment anymore",
      "communication_way": "Contact method",
      "email": "Email",
      "phone_nr": "Telephone number",
      "name": "Name",
      "new_point_balance": "New point balance",
      "note": "Note",
      "notification_subscribed": "Promotional notification",
      "surname": "Surname",
      "update_point_balance": "Update(+/-) point balance by"
    },
    "text": {
      "off": "OFF",
      "on": "ON"
    }
  }
}
